import { AxiosDeleteRequestOptions, AxiosGetRequestOptions } from '@/package';
import type { AlarmLogApi } from '@/type';
import { apiOf } from '@/util';

export const getList = apiOf<
  AlarmLogApi.GetList.Request,
  AlarmLogApi.GetList.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/alarmLog',
  }),
);

export const removeAll = apiOf<
  AlarmLogApi.RemoveAll.Request,
  AlarmLogApi.RemoveAll.Response
>(
  new AxiosDeleteRequestOptions({
    url: '/v1/miri/alarmLog/clear',
  }),
);
